import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "margin-b-standard",
  "data-testing": "mcq-card"
}
const _hoisted_2 = { class: "tools-buttons" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "btn-3 disabled margin-r-standard",
  "data-testing": "qti-card-btn-preview"
}

import { mdiDownload, mdiPencil, mdiPresentationPlay } from "@mdi/js";
import { AxiosResponse } from "axios";
import { PropType, ref } from "vue";

import API from "@/api/index";

import { useUIContentStore } from "@/stores/ui-content.store";

import { MCQResponse } from "@/models/api/mcq.model";
import { ContentStructureSection } from "@/models/content-structure.model";

import FiveATHelper from "@/utils/5AT-helper";

import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MCQ',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  },
  isContentAuthoringTier2FeatureEnabled: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const uiContentStore = useUIContentStore();

const props = __props;

const isPreviewing = ref<boolean>(false);
const goToPreview = (): void => {
  if (uiContentStore.sectionToDisplay) {
    isPreviewing.value = true;
    API.mcq
      .preview({
        var_definition: FiveATHelper.generateDefinition(props.section),
        sections_id: uiContentStore.sectionToDisplay.sectionId
      })
      .then((response: AxiosResponse<MCQResponse>): void => {
        isPreviewing.value = false;
        if (response.status === 200) {
          window.open(response.data.data.url, "_blank");
        } else {
          throw new Error("Unable to preview content");
        }
      });
  }
};

const isDownloading = ref<boolean>(false);
const triggerDownload = (): void => {
  if (uiContentStore.sectionToDisplay) {
    isDownloading.value = true;
    API.mcq
      .download({
        var_definition: FiveATHelper.generateDefinition(props.section),
        sections_id: uiContentStore.sectionToDisplay.sectionId
      })
      .then((response: AxiosResponse<MCQResponse>): void => {
        isDownloading.value = false;
        if (response.status === 200) {
          window.open(response.data.data.url);
        } else {
          throw new Error("Unable to download content");
        }
      });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RightSidebarTitle, { title: 'MCQ Mode' }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        disabled: isPreviewing.value || !__props.isContentAuthoringTier2FeatureEnabled,
        onClick: goToPreview,
        class: "btn-3",
        type: "button",
        "data-testing": "mcq-card-btn-preview"
      }, [
        _createVNode(_component_SVGIcon, { path: _unref(mdiPresentationPlay) }, null, 8, ["path"]),
        _cache[0] || (_cache[0] = _createTextVNode(" Preview "))
      ], 8, _hoisted_3),
      _createElementVNode("button", {
        disabled: isDownloading.value || !__props.isContentAuthoringTier2FeatureEnabled,
        onClick: triggerDownload,
        class: "btn-3",
        type: "button",
        "data-testing": "mcq-card-btn-download"
      }, [
        _createVNode(_component_SVGIcon, { path: _unref(mdiDownload) }, null, 8, ["path"]),
        _cache[1] || (_cache[1] = _createTextVNode(" Download "))
      ], 8, _hoisted_4),
      (!__props.isContentAuthoringTier2FeatureEnabled)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createVNode(_component_SVGIcon, { path: _unref(mdiPencil) }, null, 8, ["path"]),
            _cache[2] || (_cache[2] = _createTextVNode(" Open editor "))
          ]))
        : _createCommentVNode("", true),
      (__props.isContentAuthoringTier2FeatureEnabled)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "btn-3",
            "data-testing": "mcq-card-btn-view-link",
            to: {
          name: 'mcq',
          params: {
            productId: _unref(uiContentStore).sectionToDisplay.productId,
            sectionId: _unref(uiContentStore).sectionToDisplay.sectionId
          }
        }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SVGIcon, { path: _unref(mdiPencil) }, null, 8, ["path"]),
              _cache[3] || (_cache[3] = _createTextVNode(" Open editor "))
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})